// memoryCharged Reducer
const memoryChargedDefaultState = {
    dateNaissance: null,
    prenom: '',
    nom: '',
    address: '',
    zipCode: '',
    city: '',
    codeCountry: '',
    idBeneficiaire: '',
    email: '',
    telephone: '',
    toogle : false
};

export default (state = memoryChargedDefaultState, action) => {
    switch (action.type) {
        case 'SET_MEMEORY_CHARGED':
            return {
                ...state,
                dateNaissance: action.data.date,
                prenom: action.data.firstName,
                nom: action.data.name,
                address: action.data.address,
                zipCode: action.data.zipCode,
                city: action.data.city,
                codeCountry: action.data.codeCountry,
                email: action.data.email,
                telephone: action.data.telephone,
                idBeneficiaire: action.data.idBeneficiaire,
                toogle : action.data.toogle,
                role: 'memoryCharged'
            };
        case 'GET_MEMEORY_CHARGED':
            return {
                ...state,
                dateNaissance: action.data.dateNaissance,
                prenom: action.data.prenom,
                nom: action.data.nom,
                address: action.data.address,
                zipCode: action.data.codePostal,
                city: action.data.ville,
                codeCountry: action.data.codeCountry,
                email: action.data.email,
                telephone: action.data.telephone,
                idBeneficiaire: action.data.idBeneficiaire,
                toogle : action.data.toogle,
                role: 'memoryCharged'
            };

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/memoryCharged.js